import { types, actions } from './requests'
export const GETRECENTJOBLIST_TYPES = {
    ...types('GETRECENTJOBLIST'),
}
export const GETRECENTJOBLIST_ACTIONS = {
    ...actions('GETRECENTJOBLIST'),
}
